import React, { useState, useCallback } from 'react';
import { useToast } from '@caos/ca-component-library';
import './CopyButton.css';

interface CopyButtonProps {
  text: string;
  className?: string;
  label?: string;
  toastMessage?: string;
}

export default function CopyButton({ text, className = '', label = 'Copy', toastMessage = 'Copied to clipboard' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);
  const { showToast } = useToast();

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    }
    setCopied(true);
    showToast({ message: toastMessage, type: 'success', duration: 2000 });
    setTimeout(() => setCopied(false), 2000);
  }, [text, toastMessage, showToast]);

  return (
    <button
      type="button"
      className={`copy-btn${copied ? ' copy-btn--copied' : ''} ${className}`.trim()}
      onClick={handleCopy}
      aria-label={copied ? 'Copied' : label}
    >
      {copied ? (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
          <path d="M3 8.5l3 3 7-7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
          <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="currentColor" strokeWidth="1.3"/>
          <path d="M3 11V3.5A1.5 1.5 0 014.5 2H11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/>
        </svg>
      )}
      <span className="copy-btn-label">{copied ? 'Copied!' : label}</span>
    </button>
  );
}
